import { ExpandLess as IconExpandLess, ExpandMore as IconExpandMore } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export function MapPanelToggleCollapseButton({
    collapsed,
    onToggleCollapse,
}: {
    collapsed: boolean;
    onToggleCollapse: () => void;
}) {
    return <IconButton onClick={onToggleCollapse}>{collapsed ? <IconExpandMore /> : <IconExpandLess />}</IconButton>;
}
